import React from "react"

import PricePage from "../../components/CatalogMetal/PricePage"
import { metalCars } from "../../components/CatalogMetal/data"

const KatalizatorPage = () => <PricePage data={metalCars[1]} />

export default KatalizatorPage
